//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoFileInputBasic from './demos/DemoFileInputBasic.vue'
import DemoFileInputDense from './demos/DemoFileInputDense.vue'
import DemoFileInputVariant from './demos/DemoFileInputVariant.vue'
import DemoFileInputAccept from './demos/DemoFileInputAccept.vue'
import DemoFileInputChips from './demos/DemoFileInputChips.vue'
import DemoFileInputCounter from './demos/DemoFileInputCounter.vue'
import DemoFileInputMultiple from './demos/DemoFileInputMultiple.vue'
import DemoFileInputPrependIcon from './demos/DemoFileInputPrependIcon.vue'
import DemoFileInputHideInput from './demos/DemoFileInputHideInput.vue'
import DemoFileInputShowSize from './demos/DemoFileInputShowSize.vue'
import DemoFileInputValidation from './demos/DemoFileInputValidation.vue'
import DemoFileInputSelectionSlot from './demos/DemoFileInputSelectionSlot.vue'
import DemoFileInputLoading from './demos/DemoFileInputLoading.vue'

// code
import {
  fileInputBasic,
  fileInputDense,
  fileInputVariant,
  fileInputAccept,
  fileInputChips,
  fileInputCounter,
  fileInputMultiple,
  fileInputPrependIcon,
  fileInputHideInput,
  fileInputShowSize,
  fileInputValidation,
  fileInputSelectionSlot,
  fileInputLoading,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoFileInputBasic,
    DemoFileInputDense,
    DemoFileInputVariant,
    DemoFileInputAccept,
    DemoFileInputChips,
    DemoFileInputCounter,
    DemoFileInputMultiple,
    DemoFileInputPrependIcon,
    DemoFileInputHideInput,
    DemoFileInputShowSize,
    DemoFileInputValidation,
    DemoFileInputSelectionSlot,
    DemoFileInputLoading,
  },
  setup() {
    return {
      codeSnippets: {
        fileInputBasic,
        fileInputDense,
        fileInputVariant,
        fileInputAccept,
        fileInputChips,
        fileInputCounter,
        fileInputMultiple,
        fileInputPrependIcon,
        fileInputHideInput,
        fileInputShowSize,
        fileInputValidation,
        fileInputSelectionSlot,
        fileInputLoading,
      },
    }
  },
}
